import { render, staticRenderFns } from "./PaymentspayList.vue?vue&type=template&id=0d406ab5"
import script from "./PaymentspayList.vue?vue&type=script&lang=js"
export * from "./PaymentspayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports